export default __webpack_public_path__ + "static/fidel_deckruede_-851eea41ed107207afea6a21a953d526.jpg";